import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppDictTabComponent } from './dict.component';

const routes: Routes = [{ path: '', component: AppDictTabComponent }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppDictTabRoutingModule { }
